import { PrimaryCalendar, Storage } from '@/icons'
import { Button, Stack, Typography } from '@mui/material'
import { Card } from '@workwave-tidal/core/components'

import { FormattedMessage } from 'react-intl'

import { useTexts } from '../hooks/useTexts'

type ActionProps = {
  icon: React.ReactNode
  messageId: string
  defaultMessage: string
  buttonText: string
  onClick: () => void
  testId: string
}

type Props = {
  navigateToOrders: () => void
  openEditPlanningRange: () => void
  planType: 'none' | 'operations' | 'archived' | 'simulation'
}

export function SuggestedActions(props: Props) {
  const { navigateToOrders, openEditPlanningRange, planType } = props
  const isInOperations = planType === 'operations'

  const texts = useTexts()

  return (
    <Stack direction="column" spacing={2} data-testid="suggested-actions-section">
      <Typography variant="subtitle2" data-testid="suggested-actions-label">
        {texts.suggestedActionsTitle}
      </Typography>

      <Stack direction="column" spacing={1}>
        <Action
          icon={<Storage size={80} />}
          messageId="delete-orders-suggested-action"
          defaultMessage={texts.suggestedAction1}
          buttonText={texts.suggestedActionsReviewButtonText}
          onClick={navigateToOrders}
          testId="delete-orders-suggested-action"
        />
        {isInOperations && (
          <Action
            icon={<PrimaryCalendar size={80} />}
            messageId="reduce-planning-range-suggested-action"
            defaultMessage={texts.suggestedAction2}
            buttonText={texts.suggestedActionsReviewButtonText}
            onClick={openEditPlanningRange}
            testId="reduce-planning-range-suggested-action"
          />
        )}
      </Stack>
    </Stack>
  )
}

const Action: React.FC<ActionProps> = ({
  icon,
  messageId,
  defaultMessage,
  buttonText,
  onClick,
  testId,
}) => {
  return (
    <Card
      elevation={1}
      contentPaddingX={2}
      contentPaddingY={1.5}
      hoverStateBorderWidth={0}
      sx={{ background: '#F3F5F7', borderRadius: 1 }}
      data-testid={testId}
    >
      <Stack direction="row" spacing={2}>
        {icon}

        <Stack direction="column" spacing={2}>
          <Typography variant="body2">
            <FormattedMessage
              id={messageId}
              defaultMessage={defaultMessage}
              values={{
                b: (chunks: React.ReactNode) => (
                  <Typography component="span" variant="subtitle2" display="inline">
                    {chunks}
                  </Typography>
                ),
              }}
            />
          </Typography>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ width: 'fit-content' }}
            onClick={onClick}
            data-testid={`${testId}-review-button`}
            data-trackid={`${testId}-review-button`}
          >
            {buttonText}
          </Button>
        </Stack>
      </Stack>
    </Card>
  )
}
